import MessageML from './MessageML';
export default (props) => {
  return <MessageML {...props} />;
};
